import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const CurrencyContext = createContext({ currency: 'INR', symbol: '\u20B9', formatAmount: (n) => `\u20B9${n?.toLocaleString('en-IN') || 0}` });

const SYMBOLS = { INR: '\u20B9', USD: '$', EUR: '\u20AC', GBP: '\u00A3', AED: 'AED', SGD: 'S$', AUD: 'A$', CAD: 'C$', JPY: '\u00A5' };

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(localStorage.getItem('org_currency') || 'INR');
  const [symbol, setSymbol] = useState(localStorage.getItem('org_currency_symbol') || '\u20B9');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
    axios.get(`${API}/org-settings`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => {
        const c = r.data?.currency || 'INR';
        setCurrency(c);
        const s = SYMBOLS[c] || c;
        setSymbol(s);
        localStorage.setItem('org_currency', c);
        localStorage.setItem('org_currency_symbol', s);
      })
      .catch(() => {});
  }, []);

  const formatAmount = (amount) => {
    if (amount == null) return `${symbol}0`;
    const num = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (currency === 'INR') return `${symbol}${num.toLocaleString('en-IN')}`;
    return `${symbol}${num.toLocaleString('en-US')}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, symbol, formatAmount }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
